/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { BiShowAlt } from "react-icons/bi";
import { useQuery } from "react-query";
import { getFeedback } from "../../../../utils/api";
import Loading from "../../../../shared/Loading/Loading";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { AiOutlineArrowRight, AiOutlineArrowLeft } from "react-icons/ai";

const UsersFeedback = () => {
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const { isOpen: isShowModalOpen, onOpen: onShowModalOpen, onClose: onShowModalClose } = useDisclosure();
  const { data, isLoading, error } = useQuery("feedback", getFeedback);

  const [searchQuery, setSearchQuery] = useState(""); // New state for search query

  // Pagination
  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);

  const handlePrevPage = () => {
    setCurrentPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset page when searching
  };

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  // Filter data based on search query
  const filteredData = data.filter((feedback) =>
    (feedback.additionalFeedback && feedback.additionalFeedback.toLowerCase().includes(searchQuery.toLowerCase())) ||
    (feedback.improvements && feedback.improvements.some((improvement) => improvement.toLowerCase().includes(searchQuery.toLowerCase()))) ||
    (feedback.likes && feedback.likes.some((like) => like.toLowerCase().includes(searchQuery.toLowerCase())))
  );

  // Update pagination data
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, endIndex);

  const handleShowModal = (feedback) => {
    setSelectedFeedback(feedback);
    onShowModalOpen();
  };

  return (
    <div className="container mx-auto px-14 pb-6">
      {/* Search Bar */}

      <div className="relative my-5 max-w-md mx-auto">
        <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
          <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <input
          type="search"
          id="default-search"
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Search User's Feedback..."
          className="block p-4 pl-10 bg-gray-800 text-gray-200 rounded-md py-2 px-4 w-full"
        />
       
      </div>
      <div className="flex items-center justify-center py-6 bg-gray-900">
        <div className="col-span-12">
          <div className="overflow-auto lg:overflow-visible">
            <table className="blog-table text-gray-400 border-separate space-y-6 text-sm">
              {/* Table content */}
              <thead className="bg-gray-800 text-gray-500">
                <tr>
                  <th className="blog-th p-3">Likes Good</th>
                  <th className="blog-th p-3 text-left">Improvements</th>
                  <th className="blog-th p-3 text-left">Additional Feedback</th>
                  <th className="blog-th p-3 text-left">Show Feed</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((feedback) => (
                  <tr key={feedback.id} className="blog-tr bg-gray-800">
                    <td className="blog-td p-3">
                      {feedback.likes?.length > 0 ? (
                        <>
                          Likes:
                          {feedback.likes.map((like, index) => (
                            <p
                              key={index}
                              className="bg-green-400 text-gray-50 rounded-md px-2 m-2"
                            >
                              {index + 1}. {like}
                            </p>
                          ))}
                        </>
                      ) : (
                        <span>Likes: -</span>
                      )}
                    </td>
                    <td className="blog-td p-3">
                      {feedback.improvements?.length > 0 ? (
                        <>
                          Improvements:
                          {feedback.improvements.map((improvement, index) => (
                            <p
                              key={index}
                              className="bg-red-600 text-gray-50 rounded-md px-2 m-2"
                            >
                              {index + 1}. {improvement}
                            </p>
                          ))}
                        </>
                      ) : (
                        <span>Improvements: -</span>
                      )}
                    </td>
                    <td className="blog-td p-3 font-bold text-left">
                      {feedback.additionalFeedback ? (
                        <p>
                          Additional Feedback:{" "}
                          {feedback.additionalFeedback.slice(0, 20)}
                          {feedback.additionalFeedback?.length > 20 ? "..." : ""}
                        </p>
                      ) : (
                        <p>Additional Feedback: -</p>
                      )}
                    </td>
                    <td className="blog-td p-3 flex justify-start gap-5 items-center mt-3">
                      <a
                        href="#"
                        className="text-gray-400 hover:text-gray-100 mr-2"
                        onClick={() => handleShowModal(feedback)}
                      >
                        <BiShowAlt size={18} />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Show Modal */}
      {/* Modal content */}
      {selectedFeedback && (
        <Modal
          isCentered
          isOpen={isShowModalOpen}
          onClose={onShowModalClose}
          size="xl"
        >
          <ModalOverlay
            bg="blackAlpha.300"
            backdropFilter="blur(10px) hue-rotate(90deg)"
          />
          <ModalContent className="px-2 py-6">
            <ModalCloseButton />
            <ModalBody>
              <div className="p-4 bg-gray-800 text-gray-200">
                <h2 className="text-2xl font-semibold mb-4">Feedback Details</h2>

                <div className="border-t border-gray-600 py-2">
                  <h3 className="text-xl font-semibold mb-2">Likes:</h3>
                  <ul className="list-disc pl-6">
                    {selectedFeedback.likes.map((like, index) => (
                      <li key={index}>{like}</li>
                    ))}
                  </ul>
                </div>

                <div className="border-t border-gray-600 py-2">
                  <h3 className="text-xl font-semibold mt-4 mb-2">
                    Improvements:
                  </h3>
                  <ul className="list-disc pl-6">
                    {selectedFeedback.improvements.map((improvement, index) => (
                      <li key={index}>{improvement}</li>
                    ))}
                  </ul>
                </div>

                {selectedFeedback.additionalFeedback && (
                  <div className="border-t border-gray-600 py-2">
                    <h3 className="text-xl font-semibold mt-4 mb-2">
                      Additional Feedback:
                    </h3>
                    <p>{selectedFeedback.additionalFeedback}</p>
                  </div>
                )}
              </div>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}

      {/* Pagination */}
      <div className="flex justify-center mt-4">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className={`bg-primary text-gray-200 px-2 mr-2 rounded-md flex items-center gap-2 ${
            currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          <AiOutlineArrowLeft size={18} />
          Previous
        </button>
        <button
          onClick={handleNextPage}
          disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage) || paginatedData?.length === 0}
          className={`flex items-center gap-2 bg-primary text-gray-200 py-2 px-4 rounded-md ${
            currentPage === Math.ceil(filteredData.length / itemsPerPage) || paginatedData?.length === 0
              ? "opacity-50 cursor-not-allowed"
              : ""
          }`}
        >
          Next
          <AiOutlineArrowRight size={18} />
        </button>
      </div>
    </div>
  );
};

export default UsersFeedback;
